import { useAuth0 } from '@auth0/auth0-react'
import { AnimatePresence, motion } from 'motion/react'
import { type ReactNode } from 'react'

import { LandingPage } from '@/components/LandingPage/LandingPage'
import { LoadingScreen } from '@/components/LoadingScreen/LoadingScreen'
import { APP_PATHS } from '@/global/consts'

const AuthenticatedContent = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5, delay: 0.5, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
)

export function AuthenticationGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()

  const handleLogin = async (signup = false) => {
    const returnTo =
      window.location.pathname === '/'
        ? APP_PATHS.DEFAULT
        : `${window.location.pathname}${window.location.search}`

    await loginWithRedirect({
      appState: { returnTo },
      authorizationParams: { screen_hint: signup ? 'signup' : undefined },
    })
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  let content: ReactNode
  if (!isAuthenticated) {
    content = <LandingPage key="landing" onLogin={handleLogin} />
  } else {
    content = <AuthenticatedContent key="content">{children}</AuthenticatedContent>
  }

  return <AnimatePresence>{content}</AnimatePresence>
}
